import React, { useEffect, useState } from "react";
import arrowleft from "../assets/images/arrow-left.png";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import { showToast } from "./ShowToast";

export default function EditSwimFAQsInfo() {
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const token = GetStorage.get("xAuthToken");
  const [loading, setLoading] = useState(false);
  const [showModal, setShow] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [state, setState] = useState({
    tag: "Parent",
    question: "",
    answer: "",
    id: id,
  });

  const validationSchema = Yup.object({
    tag: Yup.string().required("Required"),
    question: Yup.string().required("Required"),
    answer: Yup.string().required("Required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    setLoading(true);

    http
      .put(`api/admin/swimmerfaq/swimmerfaqs?token=${token}`, values, id)
      .then((res) => {
        showToast("success", res.data.message);
        setLoading(false);
        resetForm();
        navigate("/swimfaqs");
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key], 8000);
              handleClose();
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message, 8000);
            handleClose();
          }
        }
      });
  };

  const GetFAQInfo = () => {
    http
      .get(`api/admin/swimmerfaq/swimmerfaqs/${id}?token=${token}`)
      .then((res) => {
        if (res?.data.length > 0) {
          setInitialValues(res.data[0]);
        }
      })
      .catch((error) => {
        console.log("error ", error.response.data.message);
      });
  };

  useEffect(() => {
    GetFAQInfo();
  }, []);

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />

          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate("/swimfaqs")}
                    type="button"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Edit Team Info</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>
            {Object.keys(initialValues).length > 0 && (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ values, handleChange, handleBlur, handleSubmit }) => (
                  <>
                    <div className="dashbord_content">
                      <div className="dashobord_inner new_team_add">
                        <h5 className="my-3">General Info</h5>
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-4 col-sm-6">
                              <div className="fomr-group">
                                <label>Select FAQ for</label>
                                <select
                                  name="tag"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.tag}
                                  className="custom_input form-control"
                                >
                                  <option value="Parent" label="Parent" />
                                  <option value="Swimmer" label="Swimmer" />
                                </select>
                                <div
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  <ErrorMessage name="tag" />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                              <div className="fomr-group">
                                <label>Question</label>
                                <input
                                  name="question"
                                  onChange={handleChange("question")}
                                  onBlur={handleBlur("question")}
                                  value={values.question}
                                  className="custom_input form-control"
                                  placeholder="Question"
                                />
                                <div
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  <ErrorMessage name="question" />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                              <div className="fomr-group">
                                <label>Answer</label>
                                <input
                                  name="answer"
                                  onChange={handleChange("answer")}
                                  onBlur={handleBlur("answer")}
                                  value={values.answer}
                                  className="custom_input form-control"
                                  placeholder="Answer"
                                />
                                <div
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  <ErrorMessage name="answer" />
                                </div>
                              </div>
                            </div>

                            <div className="col-12 d-flex justify-content-end">
                              <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                                <Link to="/swimfaqs">
                                  <button
                                    type="button"
                                    className=" them_btn_ouline  "
                                  >
                                    Cancel
                                  </button>
                                </Link>

                                <button
                                  onClick={handleSubmit}
                                  className=" them_btn_ouline  "
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </>
                )}
              </Formik>
            )}
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}
